export const navLogin = [
  {
    name: "Mis créditos",
    href: "/micredito",
  },
  {
    name: "Pagar mi cuota",
    href: "/pagar",
  },
  {
    name: "Consultar cupo",
    href: "/renovar",
  },
  {
    name: "Perfil",
    href: "/perfil",
  },
];

export const navAccess = [
  {
    name: "Iniciar sesión",
    href: "/ingresar",
  },
  {
    name: "Registrarse",
    href: "/registrarse",
  },
];